import { SIGNUP_STEPS_DIRECT_UK, SIGNUP_STEPS_PARTNER_UK } from '../constants';
import { TSignupStepsUK } from '../types';

/**
 * Calculate the furthest step id based on the current max_reached_step id and updated route.
 */
export const getMaxReachedStep = (
  currentFurthestStep: TSignupStepsUK,
  updatedFurthestStep: TSignupStepsUK,
  isDirectCustomer: boolean = false,
) => {
  const signupSteps = isDirectCustomer
    ? SIGNUP_STEPS_DIRECT_UK
    : SIGNUP_STEPS_PARTNER_UK;

  const nextStepIndex = signupSteps.findIndex(
    (step) => step === updatedFurthestStep,
  );

  const furthestStepIndex = signupSteps.findIndex(
    (step) => step === currentFurthestStep,
  );

  if (nextStepIndex <= furthestStepIndex) return currentFurthestStep;

  return updatedFurthestStep;
};
